module.exports = __webpack_public_path__ + "static/media/MOTIVATION_MIXED_HIGH.8c1d2ae2.md";